import React from "react";
import { VegaLogo, VegaLogoSmall } from "assets";
import { useAuthentication } from "domain/Authentication";

import "./user-panel.scss";
export const UserPanel = () => {
  const { user } = useAuthentication();

  return (
    <div className="user__panel" onClick={(e) => e.stopPropagation()}>
      <a href="/" className="user__panel-link">
        <VegaLogo className="user__panel-logo" />
        <VegaLogoSmall className="user__panel-logo-small" />
      </a>
      <div className="user__panel-profile">
        <div
          className="user__panel-avatar"
          style={{
            backgroundImage: `url("${user.picture}")`,
          }}
        ></div>
        <div className="user__panel-content">
          <span className="user__content-name">{user.name}</span>
          <span className="user__content-email">@{user.email?.split("@")[0] || user.email}</span>
        </div>
      </div>
    </div>
  );
};

export default UserPanel;
